import { useState } from 'react'
import { signinwithtoken } from './TokenApi'
export default function useToken() {
  const getToken = () => {
    const tokenString = localStorage.getItem('swds_token')

    const userToken = JSON.parse(tokenString)
    if (userToken !== null) {
      //checktoken(userToken)
      return userToken
    } else {
      return userToken
    }
  }
  const [token, setToken] = useState(getToken())

  const saveToken = (userToken) => {
    localStorage.setItem('swds_token', JSON.stringify(userToken))
    setToken(userToken.token)
  }

  return {
    setToken: saveToken,
    token,
  }
}
async function checktoken(token) {
  const formdata = new FormData()
  formdata.append('token', token)
  const verify_token = await signinwithtoken(formdata)
  if (verify_token.success === 1) {
    return verify_token.varTokenHash
  } else if (verify_token.success === 3) {
    return false
  }
}
